import { intersect, partial, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Request = intersect(
	struct({
		organizationId: OrganizationId,
	})
)(
	partial({
		usageId: UsageId,
	})
);
